<script>
import Layout from '@layouts/main';
import NewsForm from '@views/news/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'NewsEdit',
  components: {
    Layout,
    NewsForm,
  },
  mixins: [beforeLeaveAfterEdit],
  page() {
    return {
      title: `${this.$t('titles.edit_news')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.news'),
          to: { name: 'news.index' },
        },
        {
          text: `${this.$t('titles.edit_news')} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  methods: {
    update(callback) {
      this.setUnchanged();
      if (!callback) {
        this.$router.push({
          name: 'news.index',
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.edit_news')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <NewsForm :loaded-id="$route.params.id" @submitted="update" @entity-changed="initBeforeLeave" />
    </b-card>
  </Layout>
</template>
